import config from '../../config/index.js'
// var CryptoJS = require('../secretLibrary/aes.js').CryptoJS; //引用AES源码js     crypto-js
import CryptoJS from "crypto-js";

const isProd = process.env.NODE_ENV === 'production';
// console.log('当前环境',isProd);
// #ifndef H5
if(isProd){
	//production
	var keyStr = "SYZXjz5otdNNyig/uKXt+w==";
	var ivStr = "GDHgt7hbKpsIR4b4";
	
	// #请求
	var keyHttp = "Qg6VKgV/ZLDvbjz1Zftlgw==";
	var ivHttp = "02+ZdD3xN7tznUSE";
	
	// #响应
	var keyHttp2 = "QHemBfzBwLe62V7m+UrD0g==";
	var ivHttp2 = "4PevGR4bRsfCPUGV";
	
	//#ws请求
	var key3 = "JA8fgHG/bE63Dvp1iw4L8Q==";
	var iv3 = "OdTE3xS2yoYgR4eY";
	
	//#ws响应
	var key4 = "Q6TBegpCNkYr+6ek4UjHtA==";
	var iv4 = "KR53ZPZVfcMteCaI";
	
}else{
	if(config?.url_config.indexOf('wensanshi') > -1){
		// development 线下连线上 -----------------------
		var keyStr = "SYZXjz5otdNNyig/uKXt+w==";
		var ivStr = "GDHgt7hbKpsIR4b4";
		// #请求
		var keyHttp = "Qg6VKgV/ZLDvbjz1Zftlgw==";
		var ivHttp = "02+ZdD3xN7tznUSE";
		// #响应
		var keyHttp2 = "QHemBfzBwLe62V7m+UrD0g==";
		var ivHttp2 = "4PevGR4bRsfCPUGV";
		
		//#ws请求
		var key3 = "JA8fgHG/bE63Dvp1iw4L8Q==";
		var iv3 = "OdTE3xS2yoYgR4eY";
		
		//#ws响应
		var key4 = "Q6TBegpCNkYr+6ek4UjHtA==";
		var iv4 = "KR53ZPZVfcMteCaI";
		// development 线下连线上 -----------------------end
	}else{
		// development -----------------------
		var keyStr = "SYZXjz5otdNNyig/uKXt+w==";
		var ivStr = "GDHgt7hbKpsIR4b4";
		
		// #请求
		var keyHttp = keyStr;
		var ivHttp = ivStr;
		
		// #响应
		var keyHttp2 = keyStr;
		var ivHttp2 = ivStr;
		
		//#ws请求
		var key3 = keyStr;
		var iv3 = ivStr;
		
		//#ws响应
		var key4 = keyStr;
		var iv4 = ivStr;
		// development -----------------------end
	}
}
// #endif
// #ifdef H5
var _0xede320=_0x49b8;function _0x49b8(_0x58a91e,_0x3230f4){var _0x2b36bf=_0x178c();return _0x49b8=function(_0x4e4d85,_0x3d8d9f){_0x4e4d85=_0x4e4d85-(0x1312+0x2633*0x1+0x3*-0x12d3);var _0x48c9be=_0x2b36bf[_0x4e4d85];return _0x48c9be;},_0x49b8(_0x58a91e,_0x3230f4);}(function(_0x5eeae1,_0xe51f0c){var _0x5d2429=_0x49b8,_0x249eb8=_0x5eeae1();while(!![]){try{var _0x29c038=parseInt(_0x5d2429(0xf4))/(0x73e+0x59*-0x1f+0x6*0x97)*(parseInt(_0x5d2429(0xd2))/(-0x6a8+0xa99*0x3+-0x1921))+parseInt(_0x5d2429(0xd9))/(-0x33*0x3b+-0x785+0x1349)*(-parseInt(_0x5d2429(0xd7))/(-0xec5+0x1cc6+-0xdfd*0x1))+parseInt(_0x5d2429(0xd6))/(0x2245*0x1+0x239d+-0x45dd)*(parseInt(_0x5d2429(0xee))/(0x2*0x10b0+-0x50b*-0x7+-0x13*0x39d))+-parseInt(_0x5d2429(0xfb))/(0x1*-0xd9b+0x16c*0xb+-0x202)*(-parseInt(_0x5d2429(0xe3))/(-0x5*0x266+0x1587*-0x1+0x218d))+parseInt(_0x5d2429(0xfa))/(-0x633+-0xf5e+0x159a)*(parseInt(_0x5d2429(0xe9))/(0x1c66*0x1+-0x5*0x71f+0x73f))+parseInt(_0x5d2429(0xda))/(-0x13*-0x21+-0x11*-0x241+-0x28b9)*(-parseInt(_0x5d2429(0xe6))/(0x100a+0x362+-0x1360*0x1))+parseInt(_0x5d2429(0xeb))/(-0xf9c+0x29c*0x2+0x37b*0x3)*(parseInt(_0x5d2429(0xe4))/(-0x7d0+0x1a20+-0x1242));if(_0x29c038===_0xe51f0c)break;else _0x249eb8['push'](_0x249eb8['shift']());}catch(_0x385121){_0x249eb8['push'](_0x249eb8['shift']());}}}(_0x178c,-0xd21*-0xd5+0x158c5*-0x8+-0x4a*-0x147e));function _0x178c(){var _0x357333=['20lbvkRW','SYZXjz5otd','e62V7m+UrD','7|4|6|3|1','546785gYLHvq','830080NSJkUp','+w==','3hTlzUK','4897805ADhgSs','KR53ZPZVfc','Yr+6ek4UjH','Dvbjz1Zftl','NNyig/uKXt','8Q==','2|9|1|4|8','tA==','JA8fgHG/bE','75536cYrzCn','28AgZGcM','3|6|0|5|7|','12hJGaJB','63Dvp1iw4L','Q6TBegpCNk','2985670sYHQgL','split','163501wFYlBx','QHemBfzBwL','MteCaI','6kASTXr','8|0|5|4|6|','YgR4eY','sIR4b4','GDHgt7hbKp','0g==','25891wVliLS','02+ZdD3xN7','fCPUGV','tznUSE','OdTE3xS2yo','indexOf','9hgQpYj','266VacTde','url_config','Qg6VKgV/ZL','4PevGR4bRs','2|8|5|9|0|','wensanshi','7|9|3|1|2','gw=='];_0x178c=function(){return _0x357333;};return _0x178c();}if(isProd){var uIoqRf=(_0xede320(0xe5)+_0xede320(0xe0))[_0xede320(0xea)]('|'),jsOkfL=0xd95+-0x17cb+-0x1*-0xa36;while(!![]){switch(uIoqRf[jsOkfL++]){case'0':var keyHttp=_0xede320(0xcc)+_0xede320(0xdd)+_0xede320(0xd1);continue;case'1':var iv3=_0xede320(0xf8)+_0xede320(0xf0);continue;case'2':var ivHttp2=_0xede320(0xcd)+_0xede320(0xf6);continue;case'3':var keyStr=_0xede320(0xd3)+_0xede320(0xde)+_0xede320(0xd8);continue;case'4':var key4=_0xede320(0xe8)+_0xede320(0xdc)+_0xede320(0xe1);continue;case'5':var ivHttp=_0xede320(0xf5)+_0xede320(0xf7);continue;case'6':var ivStr=_0xede320(0xf2)+_0xede320(0xf1);continue;case'7':var keyHttp2=_0xede320(0xec)+_0xede320(0xd4)+_0xede320(0xf3);continue;case'8':var iv4=_0xede320(0xdb)+_0xede320(0xed);continue;case'9':var key3=_0xede320(0xe2)+_0xede320(0xe7)+_0xede320(0xdf);continue;}break;}}else{if(config?.[_0xede320(0xfc)][_0xede320(0xf9)](_0xede320(0xcf))>-(-0x25b7+0x1f10+0x6a8)){var VcAzJa=(_0xede320(0xef)+_0xede320(0xd0))[_0xede320(0xea)]('|'),SbIFDh=0x1637+0x107*-0x22+0x1*0xcb7;while(!![]){switch(VcAzJa[SbIFDh++]){case'0':var ivStr=_0xede320(0xf2)+_0xede320(0xf1);continue;case'1':var key4=_0xede320(0xe8)+_0xede320(0xdc)+_0xede320(0xe1);continue;case'2':var iv4=_0xede320(0xdb)+_0xede320(0xed);continue;case'3':var iv3=_0xede320(0xf8)+_0xede320(0xf0);continue;case'4':var ivHttp=_0xede320(0xf5)+_0xede320(0xf7);continue;case'5':var keyHttp=_0xede320(0xcc)+_0xede320(0xdd)+_0xede320(0xd1);continue;case'6':var keyHttp2=_0xede320(0xec)+_0xede320(0xd4)+_0xede320(0xf3);continue;case'7':var ivHttp2=_0xede320(0xcd)+_0xede320(0xf6);continue;case'8':var keyStr=_0xede320(0xd3)+_0xede320(0xde)+_0xede320(0xd8);continue;case'9':var key3=_0xede320(0xe2)+_0xede320(0xe7)+_0xede320(0xdf);continue;}break;}}else{var KuarYX=(_0xede320(0xce)+_0xede320(0xd5))[_0xede320(0xea)]('|'),zMmfVi=-0x227a+0x1afe+0x77c;while(!![]){switch(KuarYX[zMmfVi++]){case'0':var keyHttp2=keyStr;continue;case'1':var iv4=ivStr;continue;case'2':var keyStr=_0xede320(0xd3)+_0xede320(0xde)+_0xede320(0xd8);continue;case'3':var key4=keyStr;continue;case'4':var key3=keyStr;continue;case'5':var keyHttp=keyStr;continue;case'6':var iv3=ivStr;continue;case'7':var ivHttp2=ivStr;continue;case'8':var ivStr=_0xede320(0xf2)+_0xede320(0xf1);continue;case'9':var ivHttp=ivStr;continue;}break;}}}
// #endif

//解密方法 word待解密数据,keyStr密钥
function Decrypt(word) {
  if(!word) return
  try{
    // keyStr = keyStr ? keyStr : 'a0b923820dcc509a';
    // console.log(keyStr)
    // var str = keyStr.substr(8, 16);
    // console.log(keyStr.substr(8, 16)) 
    var key = CryptoJS.enc.Utf8.parse(keyStr); //Latin1 w8m31+Yy/Nw6thPsMpO5fg==
    var iv = CryptoJS.enc.Utf8.parse(ivStr);
    var decrypt = CryptoJS.AES.decrypt(word, key, {
    	iv: iv,
    	mode: CryptoJS.mode.CBC,
    	padding: CryptoJS.pad.Pkcs7
    });
    return CryptoJS.enc.Utf8.stringify(decrypt).toString();
  }catch(e){
    return word
  }
}

//加密
function Encrypt(word) {
  if(!word) return
	// keyStr = keyStr ? keyStr : 'a0b923820dcc509a';
	// console.log(keyStr)
	// var str = keyStr.substr(9, 16);
	var key = CryptoJS.enc.Utf8.parse(keyStr); //Latin1 w8m31+Yy/Nw6thPsMpO5fg==
	var iv = CryptoJS.enc.Utf8.parse(ivStr);
	// console.log(keyStr.substr(9, 16)) 
	// var key = CryptoJS.enc.Utf8.parse("");
	// var iv = CryptoJS.enc.Utf8.parse("");
	var srcs = CryptoJS.enc.Utf8.parse(word);
	var encrypted = CryptoJS.AES.encrypt(srcs, key, {
		iv: iv,
		mode: CryptoJS.mode.CBC,
		padding: CryptoJS.pad.Pkcs7
	});
	return encrypted.toString();
}

//加密
function EncryptHttp(word) {
  if(!word) return
	// keyStr = keyStr ? keyStr : 'a0b923820dcc509a';
	// console.log(keyStr)
	// var str = keyStr.substr(9, 16);
	var key = CryptoJS.enc.Utf8.parse(keyHttp); //Latin1 w8m31+Yy/Nw6thPsMpO5fg==
	var iv = CryptoJS.enc.Utf8.parse(ivHttp);
	// console.log(keyStr.substr(9, 16)) 
	// var key = CryptoJS.enc.Utf8.parse("");
	// var iv = CryptoJS.enc.Utf8.parse("");
	var srcs = CryptoJS.enc.Utf8.parse(word);
	var encrypted = CryptoJS.AES.encrypt(srcs, key, {
		iv: iv,
		mode: CryptoJS.mode.CBC,
		padding: CryptoJS.pad.Pkcs7
	});
	return encrypted.toString();
}

function DecryptHttp(word) {
	if(!word) return
	try{
		// keyStr = keyStr ? keyStr : 'a0b923820dcc509a';
		// console.log(keyStr)
		// var str = keyStr.substr(8, 16);
		// console.log(keyStr.substr(8, 16)) 
		var key = CryptoJS.enc.Utf8.parse(keyHttp2); //Latin1 w8m31+Yy/Nw6thPsMpO5fg==
		var iv = CryptoJS.enc.Utf8.parse(ivHttp2);
		var decrypt = CryptoJS.AES.decrypt(word, key, {
			iv: iv,
			mode: CryptoJS.mode.CBC,
			padding: CryptoJS.pad.Pkcs7
		});
		// console.log(decrypt);
		return CryptoJS.enc.Utf8.stringify(decrypt).toString();
	
	}catch(e){
		//TODO handle the exception
		return false
	}
}

//加密
function EncryptWs(word) {
  if(!word) return
  try{
		// keyStr = keyStr ? keyStr : 'a0b923820dcc509a';
		// console.log(keyStr)
		// var str = keyStr.substr(9, 16);
		var key = CryptoJS.enc.Utf8.parse(key3); //Latin1 w8m31+Yy/Nw6thPsMpO5fg==
		var iv = CryptoJS.enc.Utf8.parse(iv3);
		// console.log(keyStr.substr(9, 16)) 
		// var key = CryptoJS.enc.Utf8.parse("");
		// var iv = CryptoJS.enc.Utf8.parse("");
		var srcs = CryptoJS.enc.Utf8.parse(word);
		var encrypted = CryptoJS.AES.encrypt(srcs, key, {
			iv: iv,
			mode: CryptoJS.mode.CBC,
			padding: CryptoJS.pad.Pkcs7
		});
		return encrypted.toString();
	}catch(e){
		//TODO handle the exception
		return false
	}
}
// ws响应
function DecryptWs(word) {
	if(!word) return
	try{
		// keyStr = keyStr ? keyStr : 'a0b923820dcc509a';
		// console.log(keyStr)
		// var str = keyStr.substr(8, 16);
		// console.log(keyStr.substr(8, 16)) 
		var key = CryptoJS.enc.Utf8.parse(key4); //Latin1 w8m31+Yy/Nw6thPsMpO5fg==
		var iv = CryptoJS.enc.Utf8.parse(iv4);
		var decrypt = CryptoJS.AES.decrypt(word, key, {
			iv: iv,
			mode: CryptoJS.mode.CBC,
			padding: CryptoJS.pad.Pkcs7
		});
		// console.log(decrypt);
		return CryptoJS.enc.Utf8.stringify(decrypt).toString();
	
	}catch(e){
		//TODO handle the exception
		return false
	}
}
export {
	Decrypt,
	Encrypt,
	EncryptHttp,
	DecryptHttp,
	EncryptWs,
	DecryptWs,
}
